/* eslint-disable import/prefer-default-export */
import bbox from '@turf/bbox';

export const boundsExtent = (z = []) => z.reduce((acc, { geom }) => {
  if (!geom) {
    return undefined;
  }
  const [prevXlen, prevYlen] = acc;
  const [minX, minY, maxX, maxY] = bbox(geom);

  return [
    Math.max(prevXlen, maxX - minX),
    Math.max(prevYlen, maxY - minY),
  ];
}, [-Infinity, -Infinity]);
